<template>
  <div class="has-text-left">
    <span v-for="(entry, index) in crumbs" :key="entry.title">
      <span v-if="index < crumbs.length - 1">
        <router-link :to="entry.link" v-html="entry.title"> </router-link>
        /
      </span>
      <span v-else v-html="entry.title" class="has-text-grey"></span>
    </span>
    <br />
    <hr />
  </div>
</template>

<script>
export default {
  components: {},
  props: ["crumbs"],
  data() {
    return {};
  },
  created() {},
};
</script>

<style scoped lang="scss"></style>
